import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Cookies from "@/pages/Cookies";

export const Route = createFileRoute("/cookies")({
  head: () => buildHead({
    title: "Política de Cookies | OP2P CRM e Agentes de IA",
    description: "Entenda como a OP2P utiliza cookies no site: tipos de cookies, finalidades e como você pode gerenciar suas preferências de navegação.",
    path: "/cookies",
  }),
  component: Cookies,
});
